import React from 'react';
import './PrivacyPolicy.css';
import Footer from '../components/home/Footer';

function PrivacyPolicy() {
  return (
    <div className="privacy-policy">
      <div className="policy-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last updated: August 2026</p>

        <section>
          <h2>1. Introduction</h2>
          <p>
            CofounderHubs ("we," "us," "our," or "Company") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and use our services, including the HireProof hiring assessment application.
          </p>
        </section>

        <section>
          <h2>2. Information We Collect</h2>
          <p>We may collect information about you in a variety of ways. The information we may collect on the Site includes:</p>
          <ul>
            <li><strong>Personal Data:</strong> Name, email address, phone number, profile information, and other details you provide when registering or using our services.</li>
            <li><strong>Usage Data:</strong> Information about how you interact with our website, including pages visited, time spent, and actions taken.</li>
            <li><strong>Device Information:</strong> Information about your device, browser type, IP address, and operating system.</li>
            <li><strong>Cookies and Tracking:</strong> We use cookies and similar tracking technologies to enhance your experience.</li>
          </ul>
        </section>

        <section>
          <h2>3. HireProof Application</h2>
          <p>
            HireProof is our AI-powered hiring assessment platform for non-developer roles. When employers or candidates use HireProof, the application may collect candidate information such as name, email address, resume, work experience, skills, assessment answers, uploaded files, and evaluation results.
          </p>
          <p>This data is used to:</p>
          <ul>
            <li>Manage recruitment workflows</li>
            <li>Generate role-specific assessments</li>
            <li>Review candidate suitability</li>
            <li>Improve the hiring process and product quality</li>
          </ul>
          <p>
            Candidate information is shared only with authorized hiring team members and trusted service providers needed to operate the platform. Sensitive data is protected through secure access controls, encrypted connections, restricted permissions, and responsible data storage practices.
          </p>
          <p>
            Candidates should be informed how their data is used, how long it is retained, and how they can request access, correction, or deletion. AI-generated results from HireProof are used as decision support only; final hiring decisions should be reviewed by humans.
          </p>
        </section>

        <section>
          <h2>4. How We Use Your Information</h2>
          <p>We use the information we collect for various purposes:</p>
          <ul>
            <li>To provide and maintain our services, including CofounderHubs and HireProof</li>
            <li>To notify you about changes to our services</li>
            <li>To allow you to participate in interactive features</li>
            <li>To provide customer support</li>
            <li>To gather analysis or valuable information to improve our services</li>
            <li>To monitor the usage of our services</li>
            <li>To detect, prevent, and address technical and security issues</li>
          </ul>
        </section>

        <section>
          <h2>5. Disclosure of Your Information</h2>
          <p>
            We may share your information in the following situations:
          </p>
          <ul>
            <li><strong>By Law or to Protect Rights:</strong> If required by law or if we believe in good faith that disclosure is necessary to protect our rights, your safety, or the safety of others.</li>
            <li><strong>Third-Party Service Providers:</strong> We may share your information with third parties who perform services on our behalf.</li>
            <li><strong>Authorized Hiring Teams (HireProof):</strong> Assessment-related candidate data may be shared with the employer or hiring team that invited the candidate, and with processors needed to run assessments.</li>
            <li><strong>Business Transfers:</strong> If we are involved in a merger, acquisition, or asset sale, your information may be transferred as part of that transaction.</li>
          </ul>
        </section>

        <section>
          <h2>6. Security of Your Information</h2>
          <p>
            We use administrative, technical, and physical security measures to protect your personal information, including secure access controls, encrypted connections, restricted permissions, and responsible storage practices. However, no method of transmission over the Internet or electronic storage is completely secure.
          </p>
        </section>

        <section>
          <h2>7. Your Rights</h2>
          <p>
            Depending on applicable law, you may request access to, correction of, or deletion of your personal data. For HireProof candidate data, you may also ask how long assessment results are retained. Contact us using the details below to submit a request.
          </p>
        </section>

        <section>
          <h2>8. Contact Us</h2>
          <p>
            If you have questions or comments about this Privacy Policy, please contact us at:
          </p>
          <p>
            Email: hr@cofounderhubs.com<br />
            Phone: <a href="tel:+17793363216">+1 (779) 336-3216</a>
          </p>
          <p>
            You can also review this policy online at{' '}
            <a href="https://cofounderhubs.com/privacy-policy" target="_blank" rel="noopener noreferrer">
              https://cofounderhubs.com/privacy-policy
            </a>
            .
          </p>
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
